import {select} from "../../../../../shared/SagaService";

export function* parseCustomFields(transaction = {}) {
    const fields = yield select(state => state.List.fields.transaction);

    const {
        type: transactionType,
    } = transaction || {};

    const isCustomFieldShown = `${transactionType}_show`;

    const invalidFields = [];

    // eslint-disable-next-line no-param-reassign
    transaction.fields = transaction.fields.filter((obj, idx) => {
        const fieldObj = fields.find(field => field.id === obj.field_id);
        if (!fieldObj || !fieldObj[isCustomFieldShown]) {
            invalidFields.push({
                field_name: transaction.autosave_text_values.fields[idx],
                field_value: obj.value,
            });
            return false;
        }
        return true;
    });

    return invalidFields;
}
